<button class="c-button c-button--tp u-no-p" type="button" id="openPopUpInfoButton" (click)="vm.handleRefButtonClick()" data-ref>
    <i class="o-icon o-icon--info" aria-hidden="true" [ngStyle]="vm.color && {'color':vm.color}"></i>
</button>
<div class="c-popover" *ngIf="vm.isOpen">
    <div class="c-popover__container">
        <button type="button" class="c-popover__close" id="closePopUpInfoButton" (click)="vm.handleCloseButtonClick()">
            <i class="o-icon o-icon--x" aria-hidden="true"></i>
            <span class="u-sr-only">{{ 'Common.Close' | translate }}</span>
        </button>
        <p class="c-text" style="margin-bottom: 8px">
            <b>{{'Calendar.Sync_Info.Sync_Events_Info' | translate}}:</b>
            {{vm.getSyncInfoDetailed()}}
        </p>
        <p class="c-text" style="margin-bottom: 8px">
            {{'Calendar.Sync_Info.Sync_Events_Info_Detailed_Second' | translate}}
        </p>
        <p class="c-text" style="margin-bottom: 8px">
            {{'Calendar.Sync_Info.Sync_Events_Info_Detailed_Third' | translate}}
        </p>
    </div>
</div>
